export interface ConsoleLogEntry {
	level: 'error' | 'warn';
	message: string;
	timestamp: string;
}

const MAX_ENTRIES = 50;
const _buffer: ConsoleLogEntry[] = [];

const formatArgs = (args: unknown[]): string =>
	args
		.map((a) => {
			if (a instanceof Error) return `${a.name}: ${a.message}`;
			if (typeof a === 'object') {
				try {
					return JSON.stringify(a);
				} catch {
					return String(a);
				}
			}
			return String(a);
		})
		.join(' ');

const _originalError = console.error.bind(console);
const _originalWarn = console.warn.bind(console);

console.error = (...args: unknown[]) => {
	_buffer.push({ level: 'error', message: formatArgs(args), timestamp: new Date().toISOString() });
	if (_buffer.length > MAX_ENTRIES) _buffer.shift();
	_originalError(...args);
};

console.warn = (...args: unknown[]) => {
	_buffer.push({ level: 'warn', message: formatArgs(args), timestamp: new Date().toISOString() });
	if (_buffer.length > MAX_ENTRIES) _buffer.shift();
	_originalWarn(...args);
};

export const getConsoleLogs = (): ConsoleLogEntry[] => [..._buffer];
